import { WebsocketBuilder } from 'websocket-ts';
import {
  INIT_WEBSOCKET,
  onReceiveWebSocketMessage,
  setWebSocketStatus,
  SUBSCRIBE_WEBSOCKET_TOPIC,
  UNSUBSCRIBE_WEBSOCKET_TOPIC
} from '../actions/websocket';

export const WEBSOCKET_STATUS = {
  CONNECTED: 'CONNECTED'
};
export const WEBSOCKET_TOPICS = {
  SIGN_ON_MOBILE: 'mobile_signature_signed',
  SIGNME_REGISTRATION: 'signme_registration',
  SIGNME_SINGING: 'signme_signing',
  YES_SINGING: 'yes_signing',
  ATRUST_SINGING: 'atrust_signing',
  CROSS_DEVICE_DOCUMENT_COMPLETED: 'cross_device_document_completed'
};

function wsLogger(msg) {
  console.log('%c[WEBSOCKET] ' + msg, 'color: #7c0983');
}
function initWebSocket(onOpen, onMessage) {
  if (!window.ws && process.env.REACT_APP_WEBSOCKET_STAGE) {
    try {
      window.ws = new WebsocketBuilder(
        'wss://ws.paperfly.io/' +
          process.env.REACT_APP_WEBSOCKET_STAGE +
          '?token=' +
          atob(window.a1eba061831d4929b2a02deb195b6602)
      )
        .onOpen((i, ev) => {
          wsLogger('CONNECTED');
          onOpen && onOpen();
        })
        .onClose((i, ev) => {
          wsLogger('DISCONNECTED');
        })
        .onError((i, ev) => {
          wsLogger(JSON.stringify(ev));
        })
        .onMessage((i, ev) => {
          wsLogger('MESSAGE: ' + ev.data);
          onMessage(JSON.parse(ev.data));
        })
        .onRetry((i, ev) => {
          wsLogger(JSON.stringify(ev));
        })
        .build();
    } catch (e) {
      window.ws = null;
    }
  }
}

let topicWaitForConnection = {};
function isWebSocketReady() {
  return window.ws && window.ws.websocket.readyState === 1;
}

function sendWebSocket(action, data) {
  if (!isWebSocketReady()) {
    if (action === 'subscribe') {
      if (topicWaitForConnection[data] === undefined) {
        topicWaitForConnection[data] = 5;
      }
      if (topicWaitForConnection[data] === 0) {
        wsLogger('CANT_SEND: WebSocket not CONNECTED');
        return;
      } else {
        wsLogger(
          'WebSocket not ready, waiting for connection ' +
            topicWaitForConnection[data]
        );
        topicWaitForConnection[data]--;
        setTimeout(() => sendWebSocket(action, data), 1000);
        return;
      }
    } else {
      wsLogger('CANT_SEND: WebSocket not ready');
      return;
    }
  }

  const request = JSON.stringify({
    action: action,
    data: data
  });

  window.ws.send(request);
}

function subscribeWebSocket(topic, sid) {
  wsLogger('subscribe to ' + topic);

  sendWebSocket('subscribe', {
    subscriptionMapping: {
      [topic]: sid
    }
  });
}

function unSubscribeWebSocket(topic) {
  wsLogger('unsubscribe from ' + topic);

  sendWebSocket('unsubscribe', {
    topics: [topic]
  });
}

export const webSocket = store => next => action => {
  const prevState = store.getState();
  const result = next(action);
  const dispatch = store.dispatch;

  switch (action.type) {
    case INIT_WEBSOCKET:
      initWebSocket(
        () => dispatch(setWebSocketStatus(WEBSOCKET_STATUS.CONNECTED)),
        message => {
          if (message && message.topic) {
            dispatch(onReceiveWebSocketMessage(message));
          }
        }
      );
      break;

    case SUBSCRIBE_WEBSOCKET_TOPIC:
      subscribeWebSocket(action.topic, action.sid);
      break;
    case UNSUBSCRIBE_WEBSOCKET_TOPIC:
      if (prevState.wsSubscriptions.get(action.topic)) {
        unSubscribeWebSocket(action.topic);
      }
      break;

    default:
      break;
  }

  return result;
};
